module.exports = __webpack_public_path__ + "static/media/Nguyen_Minh_Quan.46a9dedf.jpg";